import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, Select } from 'antd';

const { Option } = Select;

interface LocationFormSectionProps {
  t: (key: string) => string;
  citiesByCountry: Record<string, string[]>;
}

const LocationFormSection: React.FC<LocationFormSectionProps> = ({ t, citiesByCountry }) => {
  const [selectedCountry, setSelectedCountry] = useState('CL');
  const [cityOptions, setCityOptions] = useState<string[]>(citiesByCountry['Chile']);
  const [showOtherCity, setShowOtherCity] = useState(false);

  useEffect(() => {
    const countryLabel = selectedCountry === 'CL' ? 'Chile' : 'Brazil';
    setCityOptions(citiesByCountry[countryLabel] || []);
    setShowOtherCity(false);
  }, [selectedCountry, citiesByCountry]);

  const handleCountryChange = (value: string) => {
    setSelectedCountry(value);
  };

  const handleCityChange = (value: string) => {
    setShowOtherCity(value === 'Other');
  };

  // Define countries here for dropdown
  const countries = [
    { value: 'CL', label: 'Chile' },
    { value: 'BR', label: 'Brazil' },
  ];

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Form.Item
          name="address"
          label={t('sales:properties.table.locationAddress')}
          rules={[{ required: true, message: t('common:validation.required') }]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          name="country"
          label={t('sales:properties.table.locationCountry')}
          rules={[{ required: true, message: t('common:validation.required') }]}
          initialValue="CL"
        >
          <Select onChange={handleCountryChange}>
            {countries.map(country => (
              <Option key={country.value} value={country.value}>{country.label}</Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          name="city"
          label={t('sales:properties.table.locationCity')}
          rules={[{ required: true, message: t('common:validation.required') }]}
        >
          <Select onChange={handleCityChange} allowClear>
            {cityOptions.map(city => (
              <Option key={city} value={city}>{city}</Option>
            ))}
            <Option value="Other">{t('common:other')}</Option>
          </Select>
        </Form.Item>
        {showOtherCity && (
          <Form.Item
            name="city_other"
            label={t('sales:properties.table.locationCityOther')}
            rules={[{ required: true, message: t('common:validation.required') }]}
          >
            <Input />
          </Form.Item>
        )}
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          name="pincode"
          label={t('sales:properties.table.locationPincode')}
          rules={[]}
        >
          <Input />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default LocationFormSection; 